export const RESET_NOTEPAD = "RESET_NOTEPAD";

export const API_ERROR = "NOTEPAD_API_ERROR";

export const GET_NOTEPAD = "GET_NOTEPAD";
export const SET_NOTEPAD = "SET_NOTEPAD";

export const UPDATE_NOTEPAD = "UPDATE_NOTEPAD";
export const UPDATE_NOTEPAD_SUCCESS = "UPDATE_NOTEPAD_SUCCESS";

export const SET_NOTEPAD_CONTENT = "SET_NOTEPAD_CONTENT";
export const TOGGLE_NOTEPAD = "TOGGLE_NOTEPAD";
